import { Form } from 'react-bootstrap';

import { TitleRowProps } from 'root/widgets/mrt-search-modal/types';

const TitleRow = ({
  sectionTitle,
  futureConfig,
  onFutureLinesToggle,
  shouldShowFutureLines,
  futureLabel,
}: TitleRowProps) => (
  <div className="title-row">
    <p className="section-title m-0">{sectionTitle}</p>
    {futureConfig && (
      <Form.Group>
        <Form.Check
          onChange={onFutureLinesToggle}
          checked={shouldShowFutureLines}
          className="checkbox future-line-toggle"
          type="checkbox"
          label={futureLabel}
          name="future-line"
          id="future-line-toggle"
        />
      </Form.Group>
    )}
  </div>
);

TitleRow.displayName = 'TitleRow';

export default TitleRow;
